import { useState, useEffect, useRef } from 'react'
import gsap from 'gsap';
import PrintVal from './PrintVal';
import FormatKey from './FormatKey';

const Activity = ({data})=>{
	const [expand, setExpand] = useState(false);
	const listRef = useRef(null);

	useEffect(() => {
    	if (listRef.current) {
    		if(expand){
	      		gsap.fromTo(
		        	listRef.current,
		        	{ height: 0, opacity: 0, overflow: "hidden" },
	      			{ height: "auto", opacity: 1, duration: 0.3, ease: "power2.out" }
	      		);
    		}
    	}
  	}, [expand]);

	return(
		<div className="flex flex-col gap-4">
			<p>{data.description}</p>
			<div ref={listRef} className={`${!expand && 'hidden'} flex flex-col gap-1`}>
				{
					Object.entries(data.properties).map(([key, value], index)=>{
						return <div key={index}>
							<FormatKey name={key} />: {value ? <PrintVal value={value} /> : ''}
						</div>
					})
				}
			</div>
			<span onClick={()=> setExpand(!expand)} className="text-primary font-medium cursor-pointer">{expand ? 'Show less' : 'Show more'}</span>
		</div>
	)
}

export default Activity;